export default "__VITE_ASSET__c9NqUaV1__";